var _defs, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHealth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_122",
    "data-name": "Group 122",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 108.802,
    height: 86.792,
    viewBox: "0 0 108.802 86.792",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.251
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "gray",
    stopOpacity: 0.122
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.102
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1175",
    "data-name": "Path 1175",
    d: "M279.345,132.155c-3.77-7.666-.754-14.327,4.524-18.977,7.289-3.393,14.452-1.885,19.731,4.9a16.288,16.288,0,0,1,11.436-1.634c2.783-10.482.177-23.049-9.112-29.823a27.078,27.078,0,0,0-37.834,5.921A27.078,27.078,0,1,0,236.177,136.3l43.755,31.913,11.6-16.075Z",
    transform: "translate(-214.268 -81.42)",
    fill: "url(#linear-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1177",
    "data-name": "Path 1177",
    d: "M712.429,357.424a12.9,12.9,0,0,0-22.283,13.022l13.022,22.283,22.283-13.022a12.9,12.9,0,0,0-13.022-22.283Z",
    transform: "translate(-623.044 -319.285)",
    fill: "#e53935"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1179",
    "data-name": "Path 1179",
    d: "M329.91,130.155a14.411,14.411,0,0,0-10.481,1.62,14.462,14.462,0,1,0-24.972,14.594L305.931,166l-10.64,14.59-21.849-15.936,1.84-1.075a16.439,16.439,0,0,0-14.7-29.333,16.642,16.642,0,0,0-1.889.948,16.439,16.439,0,0,0-15.79-8.07,25.929,25.929,0,0,1,.6-3.877c.033-.141.068-.284.1-.426q.212-.839.48-1.668c.014-.042.027-.086.042-.128.081-.245.167-.49.255-.734.1-.278.208-.556.32-.831.055-.138.112-.276.171-.412s.114-.266.173-.4l.006-.012c.06-.137.122-.272.186-.407.007-.016.014-.033.022-.048.057-.12.113-.239.172-.358.066-.135.133-.27.2-.4.145-.286.3-.569.454-.851.057-.1.115-.206.175-.308.071-.124.142-.247.217-.37.034-.057.068-.114.1-.171q.288-.475.6-.941.072-.109.148-.219c.068-.1.138-.2.207-.3.084-.118.167-.235.253-.353a25.889,25.889,0,0,1,36.171-5.661,25.893,25.893,0,0,1,45.943,21.906Z",
    transform: "translate(-230.017 -95.707)",
    fill: "#0e48c6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1180",
    "data-name": "Path 1180",
    d: "M160.616,382.492A14.578,14.578,0,1,0,135.445,397.2l14.711,25.172,25.172-14.711a14.578,14.578,0,1,0-14.711-25.172Z",
    transform: "translate(-133.451 -340.67)",
    fill: "#e53935"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealth);
export default __webpack_public_path__ + "static/media/Health.d827b46f8bdabda3c4c813f90edccb6e.svg";
export { ForwardRef as ReactComponent };